const MenuAmbienteController = ObjectBase.extend({
    undefinedColor: "#c4c4c4",

    colors: [
        "#fdab3d", "#00c875", "#e2445c", "#0086c0", "#579bfc", "#a25ddc", "#037f4c", "#cab641", "#ffcb00", "#333333",
        "#6e8b3d", "#02659a", "#63c8a8", "#10a1ff", "#bcee68", "#ff7373", "#9fd5d0", "#8b8b83", "#9999ff"
    ],

    items: new Array(),

    initialize: function() {
        this.extractItems();
    },

    getColor: function(ambiente, notExtractItems) {

        if (!notExtractItems) {
            this.extractItems();
        }

        if (this.items.length === 0) {
            return this.undefinedColor;
        }

        var color = this.undefinedColor;

        $.each(this.items,
            function() {
                if (this.Ambiente === ambiente) {
                    color = this.Cor;
                    return false;
                }
            });

        return color;
    },

    extractItems: function() {

        if (!this.orcamento || !this.orcamento.get("ItensOrcamento") || this.orcamento.get("ItensOrcamento").length === 0) {
            return;
        }

        var self = this;

        this.orcamento.get("ItensOrcamento").each(function(model) {

            var ambiente = model.get("Ambiente");

            if (ambiente && !model.get("CorAmbiente")) {
                model.set("CorAmbiente", self.getColor(ambiente, true));
            }

            var item = {
                Ambiente: ambiente,
                Cor: model.get("CorAmbiente")
            };

            if (ambiente && !global.isInArray(ambiente, self.items, "Ambiente")) {
                self.items.push(item);

                if (!item.Cor || item.Cor === self.undefinedColor) {
                    item.Cor = self.getUnsedColor();
                    model.set("CorAmbiente", item.Cor);
                }

            }


        });

    },

    renderItem: function(color, isEditable, item, position) {

        var li = $("<li>", { 'class': "menu-item" });

        var spanDot = $("<li>", { 'class': "dot" });
        spanDot.css("background", color);

        var divSeparator = $("<div>", { 'class': "separator" });

        if (!isEditable) {

            var a = $("<a>", { 'class': "link", href: "#", tabindex: "-1" });
            a.click($.proxy(this.itemSelected, this, item));
            li.append(a);

            a.append(spanDot);

            var spanLabel = $("<span>", { 'class': "label" });
            spanLabel.css("color", color);
            spanLabel.append(item.Ambiente);

            var iDelete = $("<i>", { 'class': "fa fa-times delete", title: "Excluir" });
            iDelete.click($.proxy(this.deleteItem, this, item));
            spanLabel.append(iDelete);

            var iEdit = $("<i>", { 'class': "fa fa-pencil edit", title: "Editar" });
            iEdit.click($.proxy(this.startEdit, this, li, item));
            spanLabel.append(iEdit);

            a.append(spanLabel);
            a.append(divSeparator);
        } else {

            var spanColor = $("<span>", { 'class': "color-label" });

            this.input = $("<input>", { 'class': "input", maxLength: 40 });
            this.input.css("color", color);
            this.input.keypress($.proxy(this.saveItem, this, false, null));
            spanColor.append(spanDot);
            spanColor.append(this.input);
            spanColor.append(divSeparator);
            li.append(spanColor);
        }

        if (position === "before") {
            this.ul.prepend(li);
        } else {
            this.ul.append(li);
        }
    },

    renderItems: function() {

        this.extractItems();

        this.ul.empty();

        var self = this;

        $.each(this.items,
            function() {
                self.renderItem(this.Cor, false, this);
            });

        this.renderActions();
    },

    renderActions: function() {

        if (this.readOnly) {
            return;
        }

        this.liActions = $("<li>", { 'class': "menu-item-acoes" });
        this.liActions.empty();
        this.renderCleanAction();
        this.renderAddAction();
        this.ul.append(this.liActions);
    },

    renderAddAction: function() {
        this.adicionarAction = $("<a>", { href: "#", 'class': "link" });
        this.adicionarAction.click($.proxy(this.addItem, this));
        this.adicionarAction.append("Adicionar");
        this.liActions.append(this.adicionarAction);
    },

    renderCleanAction: function() {
        this.adicionarAction = $("<a>", { href: "#", 'class': "link" });
        this.adicionarAction.click($.proxy(this.cleanItem, this));
        this.adicionarAction.append("Limpar");
        this.liActions.append(this.adicionarAction);
    },

    renderEditAction: function(item) {

        if (!this.liActions) {
            return;
        }

        this.liActions.empty();

        this.cancelAction = $("<a>", { href: "#", 'class': "link" });
        this.cancelAction.click($.proxy(this.cancelEditItem, this));
        this.cancelAction.append("Cancelar");
        this.liActions.append(this.cancelAction);

        this.saveAction = $("<a>", { href: "#", 'class': "link" });
        this.saveAction.click($.proxy(this.saveItem, this, true, item));
        this.saveAction.append("Salvar");
        this.liActions.append(this.saveAction);

    },

    cancelEditItem: function() {
        this.renderItems();

    },

    cleanItem: function() {

        if (this.itemSaved) {
            this.itemSaved(null, null);
        }

        this.hide();

    },

    deleteItem: function(item) {

        if (this.itemDeleted) {
            this.itemDeleted(item);
        }

        this.hide();

    },

    removeItem: function(item) {

        if (!item || !this.items || this.items.length === 0) {
            return;
        }

        for (var i = this.items.length - 1; i >= 0; i--) {
            var a = this.items[i];

            if (a.Ambiente === item.Ambiente) {
                this.items.splice(i, 1);
            }
        }

    },

    saveItem: function(byPassEnter, item, e) {

        if (this.readOnly) {
            return;
        }

        if (!byPassEnter && e && e.which && e.which !== 13) {
            return;
        }

        if (!this.input) {
            return;
        }


        if (!this.input.val()) {
            global.showErrorMessage("Informe o ambiente.");
            return;
        }

        if (this.itemSaved) {
            this.itemSaved(this.input.val(), global.rgb2hex(this.input.css("color")), item);
        }


        this.renderItems();

        this.hide();
    },

    getUnsedColor: function() {

        var color;

        var self = this;

        $.each(this.colors,
            function() {

                var c = this;
                var used = false;

                $.each(self.items,
                    function() {
                        if (this.Cor.trim() === c.trim()) {
                            used = true;
                            return false;
                        }
                    });

                if (!used) {
                    color = c;
                    return false;
                }
            });

        return color;

    },

    addItem: function() {

        if (this.readOnly) {
            return;
        }

        var color = this.getUnsedColor();
        this.renderItem(color, true, null, "before");
        this.renderEditAction();
        this.input.focus();

       
    },

    startEdit: function(li, item) {

        li.empty();

        var spanDot = $("<li>", { 'class': "dot" });
        spanDot.css("background", item.Cor);

        var divSeparator = $("<div>", { 'class': "separator" });

        var spanColor = $("<span>", { 'class': "color-label" });

        this.input = $("<input>", { 'class': "input" });
        this.input.css("color", item.Cor);
        this.input.val(item.Ambiente);
        this.input.keypress($.proxy(this.saveItem, this, false, item));
        spanColor.append(spanDot);
        spanColor.append(this.input);
        spanColor.append(divSeparator);
        li.append(spanColor);
        this.input.focus();

        this.renderEditAction(item);

    },

    itemSelected: function(item, e) {

        if ($(e.target).is("i")) {
            return;
        }

        if (this.itemSaved) {
            this.itemSaved(item.Ambiente, item.Cor);
        }

        this.hide();
    },

    updateItems: function(ultimoAmbiente, novoAmbiente) {

        if (!this.items || this.items.length === 0) {
            return null;
        }

        $.each(this.items,
            function() {
                if (this.Ambiente === ultimoAmbiente) {
                    this.Ambiente = novoAmbiente;
                }
            });
    },

    attachEvents: function() {
        $(document).mouseup($.proxy(this.hide, this));
    },

    hide: function(e) {

        if (e) {
            if (!this.ul.is(e.target) && this.ul.has(e.target).length === 0) {
                this.ul.hide();
            }
        } else {
            this.ul.hide();
        }

    },

    show: function (triggerElement) {

        if (this.readOnly && (!this.items || this.items.length === 0)) {
            return;
        }


        this.ul = $("<ul>", { 'class': "ambiente-menu" });

        this.renderItems();

        var $trigger = $(triggerElement);

        $(this.region).append(this.ul);

        var amb = $trigger.find("span[name=ambiente_item_orcamento]");
        var position = amb.offset();

        this.ul.css("top", position.top + amb.height() + 10);
        //this.ul.css("left", position.left - this.ul.width() + 50);
        this.ul.css("left", position.left - this.ul.width() + (amb.width() / 2));


        this.attachEvents();
        $(this.region).show();
        this.ul.show();

        if (!this.items || this.items.length === 0) {
            this.addItem();
        }

    }

})

window.MenuAmbienteController = MenuAmbienteController

export {
    MenuAmbienteController
}